export default "__VITE_ASSET__BzVSNtNf__"